export const unitsofmeasurement = [
  // Weight
  { id: "t", name: "Ton" },
  { id: "kg", name: "Kilogram" },
  { id: "g", name: "Gram" },
  { id: "mg", name: "Milligram" },
  { id: "lb", name: "Pound" },
  { id: "oz", name: "Ounce" },

  // Volume
  { id: "ml", name: "Milliliter" },
  { id: "l", name: "Liter" },

  // Length
  { id: "mm", name: "Millimeter" },
  { id: "cm", name: "Centimeter" },
  { id: "m", name: "Meter" },
  { id: "in", name: "Inch" },
  { id: "ft", name: "Foot" },

  // Quantity / Count
  { id: "pcs", name: "Pcs" },
  { id: "dz", name: "Dozen" },
  { id: "pk", name: "Pack" },
  { id: "box", name: "Box" },
  { id: "set", name: "Set" },
  { id: "unit", name: "Unit" },

  // Area
  { id: "sqm", name: "Square Meter" },
  { id: "sqft", name: "Square Foot" },

  // Time
  { id: "hr", name: "Hour" },
  { id: "day", name: "Day" },
  { id: "month", name: "Month" }
];

export const itemtypes = [
  { id: 'inventory', name: 'Inventory' },
  { id: 'service', name: 'Service' }
]

export function getQuantity(context, itemid) {
  const {
    purchaseinvoices,
    salesinvoices,
  } = context;

  let totalQuantityPurchased = 0;
  let totalQuantitySold = 0;

  purchaseinvoices.forEach(invoice => {
    if (invoice.items.some(item => item.accountid === itemid)) {
      invoice.items.forEach(item => {
        if (item.accountid === itemid) {
          totalQuantityPurchased += parseFloat(item.itemquantity || 0);
        }
      });
    }
  });

  salesinvoices.forEach(invoice => {
    if (invoice.items.some(item => item.accountid === itemid)) {
      invoice.items.forEach(item => {
        if (item.accountid === itemid) {
          totalQuantitySold += parseFloat(item.itemquantity || 0);
        }
      });
    }
  });

  const actualQuantity = totalQuantityPurchased - totalQuantitySold;

  return actualQuantity;
}

const conversionRates = {
  g: { base: 'kg', factor: 0.001 },
  kg: { base: 'kg', factor: 1 },
  lb: { base: 'kg', factor: 0.453592 },
  mg: { base: 'kg', factor: 0.000001 },
  l: { base: 'l', factor: 1 },
  ml: { base: 'l', factor: 0.001 },
};

function convertUnit(value, from, to) {
  if (!value || from === to) return value;

  const fromUnit = conversionRates[from];
  const toUnit = conversionRates[to];

  if (!fromUnit || !toUnit) {
    console.log(`Unsupported unit: ${from} or ${to}`);
    return value;
  }

  if (fromUnit.base !== toUnit.base) {
    console.log(`Incompatible units: ${from} and ${to}`);
    return value;
  }

  const inBase = value * fromUnit.factor;
  return inBase / toUnit.factor;
}